module.exports = __webpack_public_path__ + "img/zhaopin.e381f05c.png";